export const weekDaysDict = {
  sunday: "su",
  monday: "mo",
  tuesday: "tu",
  wednesday: "we",
  thursday: "th",
  friday: "fr",
  saturday: "sa",
} as const;

export const weekDays = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
] as const;

export type WeekDay = keyof typeof weekDaysDict;
export type WeekDayCode = typeof weekDaysDict[WeekDay];
